import * as Sentry from '@sentry/vue';

type User = {
  characterId: number;
  characterName: string;
  corpId: number;
  corpName: string;
  allianceId: number | null;
  allianceName: string | null;
};

const user = ref<User | null>(null);
const loading = ref(true);

export function useAuth() {
  async function fetchUser() {
    loading.value = true;
    if (import.meta.dev) {
      user.value = {
        characterId: 274804553,
        characterName: 'Inara Doran',
        corpId: 98740395,
        corpName: 'Ouroboros Solutions',
        allianceId: 99012664,
        allianceName: 'Recursive Horizons',
      };
      loading.value = false;
      return;
    }
    try {
      const res = await $fetch<{ user: User | null }>('/api/auth/me');
      user.value = res.user;
      if (user.value) {
        Sentry.setUser({ id: String(user.value.characterId), username: user.value.characterName });
      }
    } catch {
      user.value = null;
    } finally {
      loading.value = false;
    }
  }

  function login() {
    window.location.href = '/api/auth/login';
  }

  async function logout() {
    await $fetch('/api/auth/logout', { method: 'POST' });
    user.value = null;
    Sentry.setUser(null);
  }

  const isLoggedIn = computed(() => !!user.value);

  return {
    user,
    loading,
    isLoggedIn,
    fetchUser,
    login,
    logout,
  };
}
